// import React, { useState, useEffect } from "react";
// import axios from "axios";
// import {
//   RiAddLine,
//   RiEditLine,
//   RiDeleteBinLine,
//   RiArrowLeftSLine,
//   RiArrowRightSLine,
//   RiCloseLine,
//   RiSearchLine,
// } from "react-icons/ri";
// import toast from "react-hot-toast";
// import Swal from "sweetalert2";
// import { confirmAndDelete } from "../../utils/confirmAndDelete";

// const EventCardSkeleton = () => (
//   <div className="bg-white rounded-2xl shadow-lg border p-4 animate-pulse">
//     <div className="flex items-center justify-between mb-4">
//       <div className="h-6 bg-gray-200 rounded w-48"></div>
//       <div className="flex space-x-2">
//         <div className="h-8 w-8 bg-gray-200 rounded-lg"></div>
//         <div className="h-8 w-8 bg-gray-200 rounded-lg"></div>
//       </div>
//     </div>
//     <div className="space-y-3">
//       <div className="h-4 bg-gray-200 rounded w-full"></div>
//       <div className="h-4 bg-gray-200 rounded w-3/4"></div>
//       <div className="h-4 bg-gray-200 rounded w-2/3"></div>
//       <div className="h-4 bg-gray-200 rounded w-1/2"></div>
//     </div>
//   </div>
// );

// const AdminEvent = () => {
//   const [events, setEvents] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [isModalOpen, setIsModalOpen] = useState(false);
//   const [editingEvent, setEditingEvent] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [isSubmitting, setIsSubmitting] = useState(false);
//   const [categories, setCategories] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState("all");
//   const [selectedStatus, setSelectedStatus] = useState("all");
//   const [searchQuery, setSearchQuery] = useState("");

//   const [formData, setFormData] = useState({
//     name: "",
//     description: "",
//     team1: "",
//     team2: "",
//     category: "",
//     date: "",
//   });

//   const eventsPerPage = 4;

//   const fetchEvents = async () => {
//     try {
//       setLoading(true);
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/upcomingevent/get-all`
//       );
//       setEvents(res.data.data || []);
//     } catch (err) {
//       console.error(err);
//       setEvents([]);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const fetchCategories = async () => {
//     try {
//       const res = await axios.get(
//         `${process.env.REACT_APP_API_URL}/sports-categories/all-categories`
//       );
//       setCategories(res.data.categories || []);
//     } catch (err) {
//       console.error(err);
//       setCategories([]);
//     }
//   };

//   useEffect(() => {
//     fetchEvents();
//     fetchCategories();
//   }, []);

//   const filteredEvents = events.filter((event) => {
//     const matchesCategory =
//       selectedCategory === "all" || event.category._id === selectedCategory;

//     const matchesStatus =
//       selectedStatus === "all" || event.status === selectedStatus;

//     const matchesSearch =
//       searchQuery === "" ||
//       event.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
//       event.category.name.toLowerCase().includes(searchQuery.toLowerCase());

//     return matchesCategory && matchesStatus && matchesSearch;
//   });

//   const indexOfLast = currentPage * eventsPerPage;
//   const indexOfFirst = indexOfLast - eventsPerPage;
//   const currentEvents = filteredEvents.slice(indexOfFirst, indexOfLast);

//   // Reset to page 1 when filters change
//   useEffect(() => {
//     setCurrentPage(1);
//   }, [selectedCategory, selectedStatus, searchQuery]);

//   // Handle Form Fields
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData({ ...formData, [name]: value });
//   };

//   const openNewModal = () => {
//     setEditingEvent(null);
//     setFormData({
//       name: "",
//       description: "",
//       team1: "",
//       team2: "",
//       category: selectedCategory !== "all" ? selectedCategory : "",
//       date: "",
//     });
//     setIsModalOpen(true);
//   };

//   const openEditModal = (event) => {
//     setEditingEvent(event);

//     const dateObj = new Date(event.date);
//     const year = dateObj.getFullYear();
//     const month = String(dateObj.getMonth() + 1).padStart(2, "0");
//     const day = String(dateObj.getDate()).padStart(2, "0");
//     const hours = String(dateObj.getHours()).padStart(2, "0");
//     const minutes = String(dateObj.getMinutes()).padStart(2, "0");
//     const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;

//     setFormData({
//       name: event?.name,
//       description: event?.description,
//       team1: event?.team1,
//       team2: event?.team2,
//       category: event?.category._id,
//       date: formattedDateTime,
//     });
//     setIsModalOpen(true);
//   };

//   const deleteEvent = async (_id) => {
//     const confirmed = await confirmAndDelete({
//       id: _id,
//       url: `${process.env.REACT_APP_API_URL}/upcomingevent/delete-event`,
//     });

//     if (confirmed) {
//       const updated = events.filter((e) => e._id !== _id);
//       setEvents(updated);

//       const totalPagesAfterDelete = Math.ceil(updated.length / eventsPerPage);
//       if (currentPage > totalPagesAfterDelete) {
//         setCurrentPage(totalPagesAfterDelete || 1);
//       }

//       Swal.fire({
//         icon: "success",
//         title: "Deleted!",
//         text: "The event has been deleted successfully.",
//         confirmButtonColor: "#10B981",
//         background: "#fff",
//       });
//     } else {
//       console.error("Delete canceled or failed");
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       setIsSubmitting(true);
//       if (editingEvent) {
//         await axios.put(
//           `${process.env.REACT_APP_API_URL}/upcomingevent/update-event/${editingEvent._id}`,
//           formData
//         );
//         toast.success("Event updated successfully!");
//       } else {
//         await axios.post(
//           `${process.env.REACT_APP_API_URL}/upcomingevent/create`,
//           formData
//         );
//         toast.success("Event created successfully!");
//       }
//       setIsModalOpen(false);
//       fetchEvents();
//     } catch (err) {
//       console.error(err);
//       toast.error("Failed to save event");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-US", {
//       year: "numeric",
//       month: "long",
//       day: "numeric",
//       hour: "2-digit",
//       minute: "2-digit",
//     });
//   };

//   const totalPages = Math.ceil(filteredEvents.length / eventsPerPage);

//   return (
//     <div className="min-h-screen bg-transparent p-6 tracking-wide">
//       {/* Header */}
//       <div className="flex justify-between items-center mb-8">
//         <h1 className="text-3xl font-heading font-bold bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor bg-clip-text text-transparent">
//           All Events
//         </h1>
//         <button
//           onClick={openNewModal}
//           className="bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white py-2 px-4 rounded-xl flex items-center shadow-lg hover:shadow-xl transition-shadow"
//         >
//           <RiAddLine className="mr-2" />
//           Add Event
//         </button>
//       </div>

//       {/* Category Tabs */}
//       <div className="mb-6">
//         <div className="flex flex-wrap gap-2 mb-6">
//           <button
//             onClick={() => setSelectedCategory("all")}
//             className={`px-6 py-2.5 rounded-lg font-semibold transition-all ${
//               selectedCategory === "all"
//                 ? "bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white shadow-md"
//                 : "bg-white text-secondaryTextColor border border-gray-300 hover:border-primaryBtnColor"
//             }`}
//           >
//             All Categories
//           </button>
//           {categories.map((cat) => (
//             <button
//               key={cat._id}
//               onClick={() => setSelectedCategory(cat._id)}
//               className={`px-6 py-2.5 rounded-lg font-semibold transition-all ${
//                 selectedCategory === cat._id
//                   ? "bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white shadow-md"
//                   : "bg-white text-secondaryTextColor border border-gray-300 hover:border-primaryBtnColor"
//               }`}
//             >
//               {cat.name}
//             </button>
//           ))}
//         </div>
//       </div>

//       {/* Filters Section */}
//       <div className="bg-white rounded-2xl shadow-lg border border-primaryTextColor p-6 mb-8">
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//           {/* Status Filter */}
//           <div>
//             <label className="block text-sm font-semibold text-secondaryTextColor mb-2">
//               Filter by Status
//             </label>
//             <select
//               value={selectedStatus}
//               onChange={(e) => setSelectedStatus(e.target.value)}
//               className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-primaryBtnColor"
//             >
//               <option value="all">All Status</option>
//               <option value="upcoming">Upcoming</option>
//               <option value="complete">Complete</option>
//             </select>
//           </div>

//           {/* Search Bar */}
//           <div>
//             <label className="block text-sm font-semibold text-secondaryTextColor mb-2">
//               Search Events
//             </label>
//             <div className="relative">
//               <RiSearchLine className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
//               <input
//                 type="text"
//                 placeholder="Search by event or category..."
//                 value={searchQuery}
//                 onChange={(e) => setSearchQuery(e.target.value)}
//                 className="w-full border border-gray-300 rounded-lg p-3 pl-10 focus:outline-none focus:ring-2 focus:ring-primaryBtnColor"
//               />
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* List */}
//       <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
//         {loading ? (
//           Array.from({ length: eventsPerPage }).map((_, i) => (
//             <EventCardSkeleton key={i} />
//           ))
//         ) : currentEvents.length > 0 ? (
//           currentEvents.map((event) => (
//             <div
//               key={event._id}
//               className="bg-white rounded-2xl shadow-lg border border-primaryTextColor p-6"
//             >
//               {/* Header with title and action buttons */}
//               <div className="flex items-center justify-between mb-4">
//                 <h2 className="text-xl font-bold text-primaryTextColor font-heading capitalize">
//                   {event?.name}
//                 </h2>
//                 <div className="flex space-x-2">
//                   <button
//                     onClick={() => openEditModal(event)}
//                     className="p-2 bg-gray-100 rounded-lg text-primaryBtnHoverColor hover:bg-primaryBtnColor hover:text-white"
//                   >
//                     <RiEditLine />
//                   </button>
//                   <button
//                     onClick={() => deleteEvent(event._id)}
//                     className="p-2 bg-gray-100 rounded-lg text-red-500 hover:bg-red-500 hover:text-white"
//                   >
//                     <RiDeleteBinLine />
//                   </button>
//                 </div>
//               </div>

//               {/* Event Details */}
//               <div className="space-y-3">
//                 <p className="text-sm text-gray-600">{event.description}</p>

//                 {event.team1 && event.team2 && (
//                   <div className="flex items-center text-sm">
//                     <span className="font-semibold text-secondaryTextColor mr-2">
//                       Teams:
//                     </span>
//                     <span className="text-gray-700">
//                       {event.team1} vs {event.team2}
//                     </span>
//                   </div>
//                 )}

//                 <div className="flex items-center text-sm">
//                   <span className="font-semibold text-secondaryTextColor mr-2">
//                     Category:
//                   </span>
//                   <span className="text-gray-700">{event?.category?.name}</span>
//                 </div>

//                 <div className="flex items-center text-sm">
//                   <span className="font-semibold text-secondaryTextColor mr-2">
//                     Date:
//                   </span>
//                   <span className="text-gray-700">
//                     {formatDate(event.date)}
//                   </span>
//                 </div>
//               </div>
//             </div>
//           ))
//         ) : (
//           <div className="col-span-full text-center py-12">
//             <p className="text-gray-500 text-lg">No events found</p>
//           </div>
//         )}
//       </div>

//       {/* Pagination */}
//       {totalPages > 1 && (
//         <div className="flex justify-center items-center space-x-4">
//           <button
//             onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
//             disabled={currentPage === 1}
//             className={`p-2 rounded-lg ${
//               currentPage === 1
//                 ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                 : "bg-primaryBtnColor text-white hover:bg-primaryBtnHoverColor"
//             }`}
//           >
//             <RiArrowLeftSLine size={20} />
//           </button>
//           {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
//             <button
//               key={page}
//               onClick={() => setCurrentPage(page)}
//               className={`px-3 py-1 rounded-lg ${
//                 currentPage === page
//                   ? "bg-primaryBtnColor text-white"
//                   : "bg-gray-200 text-secondaryTextColor hover:bg-gray-300"
//               }`}
//             >
//               {page}
//             </button>
//           ))}
//           <button
//             onClick={() =>
//               currentPage < totalPages && setCurrentPage(currentPage + 1)
//             }
//             disabled={currentPage === totalPages}
//             className={`p-2 rounded-lg ${
//               currentPage === totalPages
//                 ? "bg-gray-200 text-gray-500 cursor-not-allowed"
//                 : "bg-primaryBtnColor text-white hover:bg-primaryBtnHoverColor"
//             }`}
//           >
//             <RiArrowRightSLine size={20} />
//           </button>
//         </div>
//       )}

//       {/* Modal */}
//       {isModalOpen && (
//         <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
//           <div className="bg-white rounded-2xl w-full max-w-2xl border border-primaryTextColor shadow-xl max-h-[90vh] overflow-y-auto">
//             {/* Header */}
//             <div className="flex justify-between items-center p-4 border-b border-gray-200 sticky top-0 bg-white z-10">
//               <h2 className="text-xl font-bold text-primaryTextColor">
//                 {editingEvent ? "Edit Event" : "Add New Event"}
//               </h2>
//               <button
//                 onClick={() => setIsModalOpen(false)}
//                 className="text-gray-500 hover:text-primaryBtnHoverColor"
//               >
//                 <RiCloseLine size={24} />
//               </button>
//             </div>

//             {/* Form */}
//             <form onSubmit={handleSubmit} className="p-6 space-y-4">
//               {/* Event Name */}
//               <div>
//                 <label className="block text-sm mb-2">Event Name</label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={formData?.name}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded-lg p-3"
//                 />
//               </div>
//               {/* Category */}
//               <div>
//                 <label className="block text-sm mb-2">Category</label>
//                 <select
//                   name="category"
//                   value={formData.category}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded-lg p-3"
//                 >
//                   <option value="">Select a category</option>
//                   {categories.map((cat) => (
//                     <option key={cat._id} value={cat._id}>
//                       {cat?.name}
//                     </option>
//                   ))}
//                 </select>
//               </div>

//               {/* Description */}
//               <div>
//                 <label className="block text-sm mb-2">Description</label>
//                 <textarea
//                   name="description"
//                   value={formData.description}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded-lg p-3"
//                   rows="3"
//                 />
//               </div>

//               {/* Team 1 */}
//               <div>
//                 <label className="block text-sm mb-2">Team 1</label>
//                 <input
//                   type="text"
//                   name="team1"
//                   value={formData.team1}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded-lg p-3"
//                 />
//               </div>

//               {/* Team 2 */}
//               <div>
//                 <label className="block text-sm mb-2">Team 2</label>
//                 <input
//                   type="text"
//                   name="team2"
//                   value={formData.team2}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded-lg p-3"
//                 />
//               </div>

//               {/* Date */}
//               <div>
//                 <label className="block text-sm mb-2">Event Date & Time</label>
//                 <input
//                   type="datetime-local"
//                   name="date"
//                   value={formData.date}
//                   onChange={handleChange}
//                   className="w-full border border-gray-300 rounded-lg p-3"
//                 />
//               </div>

//               {/* Action Buttons */}
//               <div className="flex justify-end space-x-3">
//                 <button
//                   type="button"
//                   onClick={() => setIsModalOpen(false)}
//                   className="bg-gray-200 text-secondaryTextColor py-2 px-4 rounded-lg hover:bg-gray-300"
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   disabled={isSubmitting}
//                   type="submit"
//                   className="bg-primaryBtnColor text-white w-40 flex items-center justify-center py-2 px-4 rounded-lg hover:bg-primaryBtnHoverColor"
//                 >
//                   {isSubmitting ? (
//                     <div className="spinner w-full"></div>
//                   ) : editingEvent ? (
//                     "Update Event"
//                   ) : (
//                     "Add Event"
//                   )}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default AdminEvent;

import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  RiAddLine,
  RiEditLine,
  RiDeleteBinLine,
  RiArrowLeftSLine,
  RiArrowRightSLine,
  RiCloseLine,
  RiSearchLine,
} from "react-icons/ri";
import toast from "react-hot-toast";
import Swal from "sweetalert2";
import { confirmAndDelete } from "../../utils/confirmAndDelete";

const EventCardSkeleton = () => (
  <div className="bg-white rounded-2xl shadow-lg border p-4 animate-pulse">
    <div className="flex items-center justify-between mb-4">
      <div className="h-6 bg-gray-200 rounded w-48"></div>
      <div className="flex space-x-2">
        <div className="h-8 w-8 bg-gray-200 rounded-lg"></div>
        <div className="h-8 w-8 bg-gray-200 rounded-lg"></div>
      </div>
    </div>
    <div className="space-y-3">
      <div className="h-4 bg-gray-200 rounded w-full"></div>
      <div className="h-4 bg-gray-200 rounded w-3/4"></div>
      <div className="h-4 bg-gray-200 rounded w-2/3"></div>
      <div className="h-4 bg-gray-200 rounded w-1/2"></div>
    </div>
  </div>
);

const AdminEvent = () => {
  const [events, setEvents] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editingEvent, setEditingEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [categories, setCategories] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("all");
  const [selectedStatus, setSelectedStatus] = useState("all");
  const [searchQuery, setSearchQuery] = useState("");

  const [formData, setFormData] = useState({
    name: "",
    description: "",
    team1: "",
    team2: "",
    category: "",
    date: "",
    duration: "",
    endTime: "",
  });

  const eventsPerPage = 4;

  const fetchEvents = async () => {
    try {
      setLoading(true);
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/upcomingevent/get-all`
      );
      setEvents(res.data.data || []);
    } catch (err) {
      console.error(err);
      setEvents([]);
    } finally {
      setLoading(false);
    }
  };

  const fetchCategories = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API_URL}/sports-categories/all-categories`
      );
      setCategories(res.data.categories || []);
    } catch (err) {
      console.error(err);
      setCategories([]);
    }
  };

  useEffect(() => {
    fetchEvents();
    fetchCategories();
  }, []);

  const filteredEvents = events.filter((event) => {
    const matchesCategory =
      selectedCategory === "all" || event.category._id === selectedCategory;

    const matchesStatus =
      selectedStatus === "all" || event.status === selectedStatus;

    const matchesSearch =
      searchQuery === "" ||
      event.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      event.category.name.toLowerCase().includes(searchQuery.toLowerCase());

    return matchesCategory && matchesStatus && matchesSearch;
  });

  const indexOfLast = currentPage * eventsPerPage;
  const indexOfFirst = indexOfLast - eventsPerPage;
  const currentEvents = filteredEvents.slice(indexOfFirst, indexOfLast);

  // Reset to page 1 when filters change
  useEffect(() => {
    setCurrentPage(1);
  }, [selectedCategory, selectedStatus, searchQuery]);

  // Handle Form Fields
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const openNewModal = () => {
    setEditingEvent(null);
    setFormData({
      name: "",
      description: "",
      team1: "",
      team2: "",
      category: selectedCategory !== "all" ? selectedCategory : "",
      date: "",
      duration: "",
      endTime: "",
    });
    setIsModalOpen(true);
  };

  const openEditModal = (event) => {
    setEditingEvent(event);

    const dateObj = new Date(event.date);
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    const hours = String(dateObj.getHours()).padStart(2, "0");
    const minutes = String(dateObj.getMinutes()).padStart(2, "0");
    const formattedDateTime = `${year}-${month}-${day}T${hours}:${minutes}`;

    let formattedEndTime = "";
    if (event.endTime) {
      const endDateObj = new Date(event.endTime);
      const endYear = endDateObj.getFullYear();
      const endMonth = String(endDateObj.getMonth() + 1).padStart(2, "0");
      const endDay = String(endDateObj.getDate()).padStart(2, "0");
      const endHours = String(endDateObj.getHours()).padStart(2, "0");
      const endMinutes = String(endDateObj.getMinutes()).padStart(2, "0");
      formattedEndTime = `${endYear}-${endMonth}-${endDay}T${endHours}:${endMinutes}`;
    }

    setFormData({
      name: event?.name,
      description: event?.description,
      team1: event?.team1,
      team2: event?.team2,
      category: event?.category._id,
      date: formattedDateTime,
      duration: event?.duration || "",
      endTime: formattedEndTime,
    });
    setIsModalOpen(true);
  };

  const deleteEvent = async (_id) => {
    const confirmed = await confirmAndDelete({
      id: _id,
      url: `${process.env.REACT_APP_API_URL}/upcomingevent/delete-event`,
    });

    if (confirmed) {
      const updated = events.filter((e) => e._id !== _id);
      setEvents(updated);

      const totalPagesAfterDelete = Math.ceil(updated.length / eventsPerPage);
      if (currentPage > totalPagesAfterDelete) {
        setCurrentPage(totalPagesAfterDelete || 1);
      }

      Swal.fire({
        icon: "success",
        title: "Deleted!",
        text: "The event has been deleted successfully.",
        confirmButtonColor: "#10B981",
        background: "#fff",
      });
    } else {
      console.error("Delete canceled or failed");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setIsSubmitting(true);

      // Create payload with only filled fields
      const payload = {
        name: formData.name,
        description: formData.description,
        team1: formData.team1,
        team2: formData.team2,
        category: formData.category,
        date: formData.date,
      };

      // Only add duration if it has a value
      if (formData.duration) {
        payload.duration = formData.duration;
      }

      // Only add endTime if it has a value
      if (formData.endTime) {
        payload.endTime = formData.endTime;
      }

      if (editingEvent) {
        await axios.put(
          `${process.env.REACT_APP_API_URL}/upcomingevent/update-event/${editingEvent._id}`,
          payload
        );
        toast.success("Event updated successfully!");
      } else {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/upcomingevent/create`,
          payload
        );
        toast.success("Event created successfully!");
      }
      setIsModalOpen(false);
      fetchEvents();
    } catch (err) {
      console.error(err);
      toast.error("Failed to save event");
    } finally {
      setIsSubmitting(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const totalPages = Math.ceil(filteredEvents.length / eventsPerPage);

  return (
    <div className="min-h-screen bg-transparent p-6 tracking-wide">
      {/* Header */}
      <div className="flex justify-between items-center mb-8">
        <h1 className="text-3xl font-heading font-bold bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor bg-clip-text text-transparent">
          All Events
        </h1>
        <button
          onClick={openNewModal}
          className="bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white py-2 px-4 rounded-xl flex items-center shadow-lg hover:shadow-xl transition-shadow"
        >
          <RiAddLine className="mr-2" />
          Add Event
        </button>
      </div>

      {/* Category Tabs */}
      <div className="mb-6">
        <div className="flex flex-wrap gap-2 mb-6">
          <button
            onClick={() => setSelectedCategory("all")}
            className={`px-6 py-2.5 rounded-lg font-semibold transition-all ${
              selectedCategory === "all"
                ? "bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white shadow-md"
                : "bg-white text-secondaryTextColor border border-gray-300 hover:border-primaryBtnColor"
            }`}
          >
            All Categories
          </button>
          {categories.map((cat) => (
            <button
              key={cat._id}
              onClick={() => setSelectedCategory(cat._id)}
              className={`px-6 py-2.5 rounded-lg font-semibold transition-all ${
                selectedCategory === cat._id
                  ? "bg-gradient-to-r from-primaryBtnColor to-primaryBtnHoverColor text-white shadow-md"
                  : "bg-white text-secondaryTextColor border border-gray-300 hover:border-primaryBtnColor"
              }`}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </div>

      {/* Filters Section */}
      <div className="bg-white rounded-2xl shadow-lg border border-primaryTextColor p-6 mb-8">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Status Filter */}
          <div>
            <label className="block text-sm font-semibold text-secondaryTextColor mb-2">
              Filter by Status
            </label>
            <select
              value={selectedStatus}
              onChange={(e) => setSelectedStatus(e.target.value)}
              className="w-full border border-gray-300 rounded-lg p-3 focus:outline-none focus:ring-2 focus:ring-primaryBtnColor"
            >
              <option value="all">All Status</option>
              <option value="upcoming">Upcoming</option>
              <option value="complete">Complete</option>
            </select>
          </div>

          {/* Search Bar */}
          <div>
            <label className="block text-sm font-semibold text-secondaryTextColor mb-2">
              Search Events
            </label>
            <div className="relative">
              <RiSearchLine className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search by event or category..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className="w-full border border-gray-300 rounded-lg p-3 pl-10 focus:outline-none focus:ring-2 focus:ring-primaryBtnColor"
              />
            </div>
          </div>
        </div>
      </div>

      {/* List */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
        {loading ? (
          Array.from({ length: eventsPerPage }).map((_, i) => (
            <EventCardSkeleton key={i} />
          ))
        ) : currentEvents.length > 0 ? (
          currentEvents.map((event) => (
            <div
              key={event._id}
              className="bg-white rounded-2xl shadow-lg border border-primaryTextColor p-6"
            >
              {/* Header with title and action buttons */}
              <div className="flex items-center justify-between mb-4">
                <h2 className="text-xl font-bold text-primaryTextColor font-heading capitalize">
                  {event?.name}
                </h2>
                <div className="flex space-x-2">
                  <button
                    onClick={() => openEditModal(event)}
                    className="p-2 bg-gray-100 rounded-lg text-primaryBtnHoverColor hover:bg-primaryBtnColor hover:text-white"
                  >
                    <RiEditLine />
                  </button>
                  <button
                    onClick={() => deleteEvent(event._id)}
                    className="p-2 bg-gray-100 rounded-lg text-red-500 hover:bg-red-500 hover:text-white"
                  >
                    <RiDeleteBinLine />
                  </button>
                </div>
              </div>

              {/* Event Details */}
              <div className="space-y-3">
                <p className="text-sm text-gray-600">{event.description}</p>

                {event.team1 && event.team2 && (
                  <div className="flex items-center text-sm">
                    <span className="font-semibold text-secondaryTextColor mr-2">
                      Teams:
                    </span>
                    <span className="text-gray-700">
                      {event.team1} vs {event.team2}
                    </span>
                  </div>
                )}

                <div className="flex items-center text-sm">
                  <span className="font-semibold text-secondaryTextColor mr-2">
                    Category:
                  </span>
                  <span className="text-gray-700">{event?.category?.name}</span>
                </div>

                <div className="flex items-center text-sm">
                  <span className="font-semibold text-secondaryTextColor mr-2">
                    Date:
                  </span>
                  <span className="text-gray-700">
                    {formatDate(event.date)}
                  </span>
                </div>

                {/* Duration */}
                {event.duration && (
                  <div className="flex items-center text-sm">
                    <span className="font-semibold text-secondaryTextColor mr-2">
                      Duration:
                    </span>
                    <span className="text-gray-700">{event.duration}</span>
                  </div>
                )}

                {/* End Time */}
                {event.endTime && (
                  <div className="flex items-center text-sm">
                    <span className="font-semibold text-secondaryTextColor mr-2">
                      End Time:
                    </span>
                    <span className="text-gray-700">
                      {formatDate(event.endTime)}
                    </span>
                  </div>
                )}
              </div>
            </div>
          ))
        ) : (
          <div className="col-span-full text-center py-12">
            <p className="text-gray-500 text-lg">No events found</p>
          </div>
        )}
      </div>

      {/* Pagination */}
      {totalPages > 1 && (
        <div className="flex justify-center items-center space-x-4">
          <button
            onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
            disabled={currentPage === 1}
            className={`p-2 rounded-lg ${
              currentPage === 1
                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                : "bg-primaryBtnColor text-white hover:bg-primaryBtnHoverColor"
            }`}
          >
            <RiArrowLeftSLine size={20} />
          </button>
          {Array.from({ length: totalPages }, (_, i) => i + 1).map((page) => (
            <button
              key={page}
              onClick={() => setCurrentPage(page)}
              className={`px-3 py-1 rounded-lg ${
                currentPage === page
                  ? "bg-primaryBtnColor text-white"
                  : "bg-gray-200 text-secondaryTextColor hover:bg-gray-300"
              }`}
            >
              {page}
            </button>
          ))}
          <button
            onClick={() =>
              currentPage < totalPages && setCurrentPage(currentPage + 1)
            }
            disabled={currentPage === totalPages}
            className={`p-2 rounded-lg ${
              currentPage === totalPages
                ? "bg-gray-200 text-gray-500 cursor-not-allowed"
                : "bg-primaryBtnColor text-white hover:bg-primaryBtnHoverColor"
            }`}
          >
            <RiArrowRightSLine size={20} />
          </button>
        </div>
      )}

      {/* Modal */}
      {isModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl w-full max-w-2xl border border-primaryTextColor shadow-xl max-h-[90vh] overflow-y-auto">
            {/* Header */}
            <div className="flex justify-between items-center p-4 border-b border-gray-200 sticky top-0 bg-white z-10">
              <h2 className="text-xl font-bold text-primaryTextColor">
                {editingEvent ? "Edit Event" : "Add New Event"}
              </h2>
              <button
                onClick={() => setIsModalOpen(false)}
                className="text-gray-500 hover:text-primaryBtnHoverColor"
              >
                <RiCloseLine size={24} />
              </button>
            </div>

            {/* Form */}
            <form onSubmit={handleSubmit} className="p-6 space-y-4">
              {/* Event Name */}
              <div>
                <label className="block text-sm mb-2">Event Name</label>
                <input
                  type="text"
                  name="name"
                  value={formData?.name}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3"
                />
              </div>
              {/* Category */}
              <div>
                <label className="block text-sm mb-2">Category</label>
                <select
                  name="category"
                  value={formData.category}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3"
                >
                  <option value="">Select a category</option>
                  {categories.map((cat) => (
                    <option key={cat._id} value={cat._id}>
                      {cat?.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* Description */}
              <div>
                <label className="block text-sm mb-2">Description</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3"
                  rows="3"
                />
              </div>

              {/* Team 1 */}
              <div>
                <label className="block text-sm mb-2">Team 1</label>
                <input
                  type="text"
                  name="team1"
                  value={formData.team1}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3"
                />
              </div>

              {/* Team 2 */}
              <div>
                <label className="block text-sm mb-2">Team 2</label>
                <input
                  type="text"
                  name="team2"
                  value={formData.team2}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3"
                />
              </div>

              {/* Date */}
              <div>
                <label className="block text-sm mb-2">Event Date & Time</label>
                <input
                  type="datetime-local"
                  name="date"
                  value={formData.date}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3"
                />
              </div>

              {/* Duration */}
              <div>
                <label className="block text-sm mb-2">
                  Duration (Optional)
                </label>
                <input
                  type="text"
                  name="duration"
                  value={formData.duration}
                  onChange={handleChange}
                  placeholder="e.g., 2 hours"
                  className="w-full border border-gray-300 rounded-lg p-3"
                />
              </div>

              {/* End Time */}
              <div>
                <label className="block text-sm mb-2">
                  End Time (Optional)
                </label>
                <input
                  type="datetime-local"
                  name="endTime"
                  value={formData.endTime}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded-lg p-3"
                />
              </div>

              {/* Action Buttons */}
              <div className="flex justify-end space-x-3">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="bg-gray-200 text-secondaryTextColor py-2 px-4 rounded-lg hover:bg-gray-300"
                >
                  Cancel
                </button>
                <button
                  disabled={isSubmitting}
                  type="submit"
                  className="bg-primaryBtnColor text-white w-40 flex items-center justify-center py-2 px-4 rounded-lg hover:bg-primaryBtnHoverColor"
                >
                  {isSubmitting ? (
                    <div className="spinner w-full"></div>
                  ) : editingEvent ? (
                    "Update Event"
                  ) : (
                    "Add Event"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdminEvent;
